import React from "react"
import PropTypes from "prop-types"


const Image = ({ className, styled, src, alt }) => {

  let style = "media-style stacked-margin";

  return (
    <div className={className}>
      <img className={styled && style} src={src} alt={alt}/>
    </div>
  )
}

Image.defaultProps = {
  className: ``,
  styled: true,
  src: `https://images-mmoore.s3.amazonaws.com/placeholderImage.png`,
  alt: ``,
}

export default Image
